import React, { useState, useMemo } from "react";
import { Box, Typography, useTheme } from "@mui/material";
import {
  PieChart,
  Pie,
  Cell,
  ResponsiveContainer,
  Tooltip as RechartsTooltip,
  Legend,
} from "recharts";

const AumDonut = ({ aumDistributions }) => {
  const theme = useTheme();

  // Only keep distributions that actually have data
  const distributionKeys = useMemo(
    () =>
      Object.keys(aumDistributions || {}).filter(
        (key) => (aumDistributions[key]?.data || []).length > 0
      ),
    [aumDistributions]
  );

  const [activeKey, setActiveKey] = useState(distributionKeys[0] || null);
  const activeDist = activeKey ? aumDistributions[activeKey] : null;
  const aumChartData = activeDist?.data || [];

  const sliceColors = [
    theme.palette.primary.main,
    theme.palette.secondary.main,
    theme.palette.info.main,
    theme.palette.success.main,
    theme.palette.warning.main,
    theme.palette.error.main,
  ];

  // Nothing at all
  if (!distributionKeys.length) {
    return (
      <Box
        sx={{
          flex: 1,
          minWidth: { xs: "100%", md: 0 },
          height: 260,
          display: "flex",
          flexDirection: "column",
          gap: 1,
          justifyContent: "center",
          alignItems: "center",
          fontSize: "0.8rem",
          color: theme.palette.text.disabled,
        }}
      >
        No AUM distribution data
      </Box>
    );
  }

  return (
    <Box
      sx={{
        flex: 1,
        minWidth: { xs: "100%", md: 0 },
        height: 260,
        display: "flex",
        flexDirection: "column",
        gap: 1.25,
      }}
    >
      {/* Header + distribution toggle pills */}
      <Box
        sx={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
          gap: 1.5,
          background: "#003366",
        }}
      >
        <Typography
          sx={{
            fontSize: "0.8rem",
            fontWeight: 600,

            textTransform: "uppercase",
            letterSpacing: 0.4,
            mx: "auto",
            py: 1,
            color: "white",
          }}
        >
          AUM Distribution
        </Typography>

        {/* <Box sx={{ display: "flex", gap: 0.5, flexWrap: "wrap" }}>
          {distributionKeys.map((key) => {
            const label = aumDistributions[key].label || key;
            const isActive = key === activeKey;
            return (
              <Box
                key={key}
                onClick={() => setActiveKey(key)}
                sx={{
                  px: 1.4,
                  py: 0.4,
                  borderRadius: 999,
                  fontSize: "0.7rem",
                  cursor: "pointer",
                  border: `1px solid ${
                    isActive
                      ? theme.palette.primary.main
                      : theme.palette.divider
                  }`,
                  bgcolor: isActive
                    ? theme.palette.primary.soft
                    : "transparent",
                  color: isActive
                    ? theme.palette.primary.main
                    : theme.palette.text.secondary,
                  transition: "all 0.15s ease",
                  "&:hover": {
                    borderColor: theme.palette.primary.light,
                  },
                }}
              >
                {label}
              </Box>
            );
          })}
        </Box> */}
      </Box>

      {/* Donut */}
      {aumChartData.length > 0 ? (
        <ResponsiveContainer width="100%" height="100%">
          <PieChart>
            <Pie
              label={false}
              data={aumChartData}
              dataKey="value"
              nameKey="name"
              cx="50%"
              cy="50%"
              outerRadius="75%"
              innerRadius="45%" // donut
              paddingAngle={2}
            >
              {aumChartData.map((entry, index) => (
                <Cell
                  key={`cell-${entry.name}-${index}`}
                  fill={sliceColors[index % sliceColors.length]}
                />
              ))}
            </Pie>

            <RechartsTooltip
              formatter={(value) => `${value.toFixed(1)}%`}
              contentStyle={{
                borderRadius: 8,
                border: "none",
                background: "white",
                color: "black",
                fontSize: "0.75rem",
              }}
            />

            <Legend
              verticalAlign="bottom"
              height={24}
              wrapperStyle={{ fontSize: "0.75rem" }}
            />
          </PieChart>
        </ResponsiveContainer>
      ) : (
        <Box
          sx={{
            flex: 1,
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            fontSize: "0.8rem",
            color: theme.palette.text.disabled,
          }}
        >
          No data for {activeDist?.label || "selected view"}
        </Box>
      )}
    </Box>
  );
};

export default AumDonut;
